// removed by extract-text-webpack-plugin
module.exports = {"mono":"InputNameEditor__mono___31dt9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InputNameEditor/InputNameEditor.css
// module id = 960
// module chunks = 0